export default __webpack_public_path__ + "static/backgroundPattern_compressed-b3cf82782ce92eaf6c1d563448228937.svg";